<template>
  <ModalDialog
    v-if="value"
    title="加入對戰"
    :hide-cancel="true"
    confirm-text="確定送出"
    :value="value"
    size="sm"
    no-content-gap
    @input="$emit('input', $event)"
    @confirm="joinLobby"
  >
    <b-form @submit.prevent="joinLobby">
      <b-form-input
        v-model="code"
        :placeholder="$t('請輸入對戰號碼')"
        autocomplete="off"
        autofocus
      ></b-form-input>
    </b-form>
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/Modal/ModalDialog.vue';
import pvpService from '@/services/pvp.js';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalDialog,
  },
  data() {
    return {
      code: '',
    };
  },
  methods: {
    async joinLobby() {
      this.$store.commit('env/setIsLoading', true);
      try {
        const id = this.code;
        await pvpService.enterLobby(id);
        this.code = '';
        this.$router.push({name: 'pvp-lobby', params: {id}});
      } catch (error) {
        this.$alert(error?.message || error);
      }
      this.$emit('input', false);
      this.$store.commit('env/setIsLoading', false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
